// Board menu in the parent app, in English (see boardViewApp.nl.ts).
export const appBoardViewEn = {
    title: 'Board',
    intro: 'This is the board right now, live. View only: tap on the board itself.',
    choose: 'Board',
    lastSeen: 'Last seen {when}',
    neverSeen: 'Not seen yet',
    virtual: 'Virtual iPad',
    viewOnly: 'View only',
    loading: 'Loading the board…',
    reconnecting: 'Reconnecting…',
    revoked: 'This board has been unpaired.',
    failed: 'Could not show the board.',
    retry: 'Try again',
    frameTitle: 'Board {name}, view only',
    parentsOnly: 'Only parents can view the board here.',
    emptyTitle: 'No board yet',
    emptyText: 'Pair a tablet and you will see the board here.',
    emptyLink: 'Pair a tablet',
};
//# sourceMappingURL=boardViewApp.en.js.map